import { render, staticRenderFns } from "./browse-space.vue?vue&type=template&id=cc9a9894"
import script from "./browse-space.vue?vue&type=script&lang=js"
export * from "./browse-space.vue?vue&type=script&lang=js"
import style0 from "./browse-space.vue?vue&type=style&index=0&id=cc9a9894&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports